import { createSelector } from 'reselect'

const qsSelector = state => state.qs

export default createSelector(
	[qsSelector],
	qsSelectorData => ({
		lerr: qsSelectorData.lerr,
	})
)
